import { gql } from '@apollo/client';

export const GET_MONITORING_FORM = gql`
  query GetMonitoringForm($id: ID!) {
    monitoringForm: getMonitoringForm(id: $id) {
      id
      name
      indicators {
        id
        indicator {
          id
          name
          dimensions {
            id
            index
            name
          }
        }
        dimensions
        site {
          id
          name
        }
      }
      reporterSubmissions {
        id
        updatedAt
        status
        statusDate
        periodNumber
        reporter {
          id
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
          }
        }
        respondent {
          id
          lastName
          firstName
          email
        }
      }
      reporters {
        id
        funder {
          id
          name
        }
        serviceProvider {
          id
          name
        }
        institution {
          id
          name
        }
      }
      formReporters {
        id
        sites {
          id
        }
        organisation {
          id
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
          }
        }
      }
      users {
        user {
          id
          firstName
        }
        sites {
          id
        }
        formRole {
          id
          name
        }
      }
    }
  }
`;
